import React from 'react';
import { getUploadUrl } from '../services/api';
import './Crest.css';

function iniciais(nome) {
  if (!nome) return '?';
  const partes = nome.trim().split(/\s+/);
  return partes.length > 1
    ? (partes[0][0] + partes[1][0]).toUpperCase()
    : partes[0].slice(0, 2).toUpperCase();
}

// Escudo do time: usa a imagem cadastrada (times.escudo) quando existe,
// senão cai nas iniciais do nome — nunca quebra com imagem ausente.
export default function Crest({ nome, escudo, size = 'md' }) {
  return (
    <span className={`crest crest--${size}`}>
      {escudo
        ? <img src={getUploadUrl(escudo)} alt={nome} />
        : iniciais(nome)}
    </span>
  );
}
